import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import Button from "../../atoms/button/button";
import FormInput from "../../atoms/form-input/FormInput";
import "./FormBottom.scss";
import rawToReact from "../../../utils/rawToReact";
import useBrowserMode from "../../../shared/hooks/useBrowserMode"
import { navigate} from "gatsby";
import contentfulRenderOptions from "../../../utils/contentfulRenderOption";
import { useLocation } from '@reach/router';
import arrowright from "../../../assets/images/icons/flecha-dere.png";

interface IBottomForm {
    titleButton: string;
    activeWizard?: boolean;
    setActiveIndex: Dispatch<SetStateAction<number>>;
    activeIndex: number;
    onclick?: () => any,
    onClickReturn?: () => any,
    inputs: any;
    endIndex: number;
    validateRequired: any;
    inputsErrorList: any;
    setInputValue: any;
    formValues: any;
    handleSubmitForm: any;
    isDisabled?: boolean;
    handleEvent?: any;
    dateState?: any;
    talleresData?: any;
    getActiveIndex?: (index: number) => void;
    handleCancelButton?: any;
    setCurrentIndex?: any;
    handleBigCancelButton?: any;
}

const FormBottom = (props: IBottomForm) => {

    const [, setShowModal] = useState<boolean>(false);
    const location = useLocation();
    const currentPath = location.pathname; // Obtiene la ruta actual




    const {
        titleButton,
        onclick,
        activeWizard,
        setActiveIndex,
        activeIndex,
        inputs,
        endIndex,
        validateRequired,
        setInputValue,
        handleSubmitForm,
        formValues,
        isDisabled,
        handleEvent,
        dateState,
        talleresData,
        getActiveIndex,
        handleCancelButton,
        setCurrentIndex,
    } = props;

    // Cuando se hace click en el boton continuar se validan los campos requeridos
    // en caso de que  alguno no este diligenciado muestra el error y no continua.
    const handleClick = () => {
        const currentIndex = activeIndex + 1;

        if(handleEvent != undefined){
            handleEvent();
        }

        validateRequired();

        if (validateRequired().length === 0) {
            if (currentIndex < endIndex) {
                setActiveIndex(currentIndex);
            } else {
                handleSubmitForm();
            }
        }

        getActiveIndex && getActiveIndex(currentIndex);

        if (setCurrentIndex) {
            setCurrentIndex(currentIndex);
        }
    };

    const handleClickBackRuta = () => {
        const isInitialPath = currentPath.endsWith("/ruta-ideal/");
        if (activeIndex === 0 && isInitialPath) {
          navigate("/personas");
        } else if (activeIndex > 0) {
          setActiveIndex(activeIndex - 1);
          document.querySelector(".m-form-wizard")?.scrollIntoView();
          getActiveIndex && getActiveIndex(activeIndex);
          setCurrentIndex && setCurrentIndex(activeIndex - 1);
        }
      };

    //Bloque creado para google tag manager
    let gtmValue = ''

    // para desplegar en localhost se usa const pathName = isBrowser ? window.location.pathname.split('/')[4] : ''

    const { isBrowser, window} = useBrowserMode()
    const pathName = isBrowser ? window.location.pathname.split('/')[5] : ''
    const pathNameForOtherForms = isBrowser ? window.location.pathname : ''

    const gtmBasedOnPathName = () => {

        if (titleButton === 'ENVIAR' && (pathName === 'talleres' || pathName === 'talleres-mentor')) {

            // Tiene trabajo SI
            if (formValues.formal_employee === 'Si') {
                if (formValues.has_disability === 'Si') {
                    if (formValues.interested_disability === 'Si') {
                        gtmValue = 'gtm_btn_enviar_empleado_discapacidad_si_taller_si'
                    } else {
                        gtmValue = 'gtm_btn_enviar_empleado_discapacidad_si_taller_no'
                    }
                } else if (formValues.has_disability === 'No') {
                    if (formValues.interest_line === 'No me interesa ninguna') {
                        gtmValue = 'gtm_btn_enviar_empleado_discapacidad_no_taller_no'
                    } else {
                        gtmValue = 'gtm_btn_enviar_empleado_discapacidad_no_taller_si'
                    }
                }
            } else if (formValues.formal_employee === 'No') { // Tiene trabajo NO
                if (formValues.has_disability === 'Si') {
                    if (formValues.interested_disability === 'Si') {
                        gtmValue = 'gtm_btn_enviar_empleado_no_discapacidad_si_taller_si'
                    } else {
                        gtmValue = 'gtm_btn_enviar_empleado_no_discapacidad_si_taller_no'
                    }
                } else if (formValues.has_disability === 'No') {
                    if (formValues.interest_line === 'No me interesa ninguna') {
                        gtmValue = 'gtm_btn_enviar_empleado_no_discapacidad_no_taller_no'
                    } else {
                        gtmValue = 'gtm_btn_enviar_empleado_no_discapacidad_no_taller_si'
                    }
                }
            }

        } else if (titleButton === 'ENVIAR' && pathName === 'cursos') {
            gtmValue = 'gtm_btn_enviar_cursos'
        } else if (titleButton === 'SOLICITAR' && pathName === 'foro') {
            gtmValue = 'gtm_solicitar_nueva_conversacion_foro_comunidades'
        } else if (titleButton === 'FINALIZAR' && pathNameForOtherForms.includes("unete")) {
            gtmValue = 'gtm_finalizar_formulario_unete_a_la_comunidad'
        } 
        else {
            gtmValue = `gtmFormButton-${titleButton}`;
        }

        return gtmValue
    }


    return (
        <div className="m-form-bottom">
            {/* Renderiza el campo para la autorizacion de datos. */}
            {inputs?.map((input, index) => {
                if (input.nombreId === "dataProcessingAuthorization") {
                    return (
                        <>
                            {input.tituloBotonTerminos && (
                                <div className="m-form-bottom__authorization">
                                    <div
                                        className={
                                            "m-form-bottom__authorization__texto-terminos"
                                        }
                                    >
                                        {/* renderiza los terminos para la autorizacion de datos. */}
                                        {rawToReact(
                                            input.textoTerminos.raw,
                                            contentfulRenderOptions
                                        )}
                                    </div>
                                    {/* Renderiza el checkbox para la autorizacion de datos */}
                                    <div className="m-form-bottom__authorization__checkbox">
                                        <FormInput
                                            key={index}
                                            title={""}
                                            errorMessage={input.mensajeError}
                                            value={""}
                                            nombreId={input.nombreId}
                                            textoTerminos=""
                                            type={input.tipoCampo}
                                            setInputValue={setInputValue}
                                            isError={
                                                props.inputsErrorList.indexOf(
                                                    input.nombreId
                                                ) !== -1
                                            }
                                            tituloBotonTerminos={
                                                input.tituloBotonTerminos
                                            }
                                            checked={
                                                formValues[input.nombreId]
                                                    ? true
                                                    : false
                                            }
                                            dateState={dateState}
                                            ayuda={input.ayuda}
                                            talleresData={talleresData}
                                            listValue={input.listValue || []}
                                        ></FormInput>
                                    </div>
                                </div>
                            )}
                        </>
                    );
                }
            })}

            {/* Si el wizard esta activo, se renderiza el boton VOLVER */}
            <div className="m-form-bottom__navigation">
                {activeWizard && activeIndex > 0 && (
                    <>
                        <Button
                            type="button"
                            classname={`primary m-form-bottom__navigation-button-back`}
                            text={<><img className="backward-arrow" src={arrowright} alt="Flecha izquierda"/>Volver</>}
                            isDisabled={activeIndex === 0 && !currentPath.endsWith("/ruta-ideal/")}
                            onClickAction={() => {
                                handleClickBackRuta();
                            }}
                        ></Button>

                    </>
                )}

                {/* Boton CONTINUAR/FINALIZAR siempre se renderiza */}
                <>
                    <Button
                        type="button"
                        classname={`a-button__magenta m-form-bottom__navigation-button-next ${gtmBasedOnPathName()}`}
                        text={<>{titleButton} <img className="forward-arrow" src={arrowright} alt="Flecha derecha"/></>}
                        isDisabled={isDisabled}
                        onClickAction={onclick || handleClick}
                    ></Button>
                </>
            </div>
            {handleCancelButton && (
                <>
                  <Button
                     type="button"
                     classname={`gtmFormButton-cancel`}
                     text="CANCELAR"
                     isDisabled={false}
                  ></Button>
               </>
            )}

        </div>
    );
};

export default FormBottom;
